import {BackendCaller, IBackendCaller} from "./backendCaller";
/* istanbul ignore file */

const clientConfigurationDefaultUrl = "/api/clientconfiguration";

export interface IClientConfigurationService {
  getClientConfiguration: () => Promise<any>;
}

/**
 * Handle the client configuration API connection and operations.
 */
export class ClientConfigurationService implements IClientConfigurationService {
  backendCaller: IBackendCaller;

  constructor() {
    this.backendCaller = new BackendCaller();
  }

  /**
   * Get the configuration of the app from the API endpoint.
   */
  getClientConfiguration = async () => {
    return await this.backendCaller.callApi(
      "GET",
      `${clientConfigurationDefaultUrl}`,
      null
    );
  };
}
